/* jQuery, Bloodhound */

'use strict';

import '../../../js/vendor/typeaheadjs/dist/typeahead.jquery.js';
import Bloodhound from '../../../js/vendor/typeaheadjs/dist/bloodhound.min.js';

class TypeaheadSolr {
    wrap;
    bloodhoundArr;
    ui;

    constructor(options) {
        if (options.wrap) {
            this.wrap = options.wrap;
        }

        if (this.wrap) {
            this.ui = {
                typeaheadForm: $('.js-typeahead-solr'),
                typeaheadInputs: $('.js-typeahead-solr-input'),
                searchType: $('.js-typeahead-input-search-type')
            };
            this.bloodhoundArr = [];
            window.addEventListener('load', () => this.implementTypeahead());

            if (this.ui.searchType.length) {
                $(this.wrap).bind('typeahead:select', (ev, suggestion) => {
                    suggestion.type ?
                        $(this.ui.searchType).val(suggestion.type) :
                        $(this.ui.searchType).val('');

                    this.wrap.submit();
                });
            }
        }
    }

    implementTypeahead() {

        const endpointUrl = $('input#endpoint').val();
        const siteName = $('input#sitename').val();

        let searchData;

        this.ui.typeaheadInputs.each((index, el) => {
            var $thisInput = $(el);

            searchData = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                limit: 10,
                remote: {
                    url: `${endpointUrl}?keyword=%KEYWORD&sitename=${siteName}`,
                    wildcard: '%KEYWORD',
                    rateLimitBy: 'debounce',
                    rateLimitWait: 300,
                    transform: function (list) {
                        return list.map(function (result) {
                            return {
                                displayName: result.DisplayText,
                                name: result.DisplayText,
                                type: result.Type,
                                value: result.Url
                            };
                        });
                    }
                },
            });

            $thisInput.typeahead({
                minLength: 2,
                hint: false,
                highlight: true
            }, {
                displayKey: 'displayName',
                display: 'displayName',
                limit: 7,
                templates: {
                    header: (data) => data.displayName ? `
                        <h3 class="twitter-typeahead__header">${data.displayName}</h3>
                    ` : undefined,
                    suggestion: (data) => `
                        <div class="twitter-typeahead__suggestion">
                            <span class="twitter-typeahead__suggestion-name">${data.displayName}</span>
                        </div>
                    `
                },
                // `ttAdapter` wraps the suggestion engine in an adapter that
                // is compatible with the typeahead jQuery plugin
                source: searchData.ttAdapter()
            });
        });

        $(this.wrap).bind('typeahead:render', () => {
            var $suggestionGroupNames = $('.twitter-typeahead__suggestion');

            $suggestionGroupNames.each(function() {
                var $this = $(this),
                    $thisText = $this.find('.twitter-typeahead__suggestion-name')[0].innerText.toLowerCase();

                if ($thisText === 'services' || $thisText === 'doctors' || $thisText === 'locations') {
                    $this.addClass('twitter-typeahead__suggestion-title--override');
                }
            });
        });
    }
}

export default TypeaheadSolr;
